module.exports = __webpack_public_path__ + "img/1335893414.2505eb60.jpg";